import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "api/tanStackQuery/queryClient";
import App from "app/App";
import { StyleProviders } from "app/AppProviders";
import { AuthProvider } from "app/Auth/AuthBoundary";
import { NetworkToastProvider } from "features/CenterContent/shared/NetworkToastProvider";
import ReactDOM from "react-dom/client";
import "i18n.js";

// We must wait for worker.start() before rendering, else it will be a race condition
async function enableMocking() {
  if (import.meta.env.DEV && import.meta.env.VITE_MSW_ENABLED === "true") {
    try {
      const { worker } = await import("./mocks/browser");
      await worker.start();
    } catch {
      // eslint-disable-next-line no-alert -- only used in dev while mocking data
      alert(
        "Failed to enable mocking.\nDelete `node_modules` and type `npm i` to possibly fix.",
      );
    }
  }
}

void enableMocking().then(() =>
  ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <QueryClientProvider client={queryClient}>
      <NetworkToastProvider>
        <StyleProviders>
          <AuthProvider>
            <App />
          </AuthProvider>
        </StyleProviders>
      </NetworkToastProvider>
    </QueryClientProvider>,
  ),
);
